import type { Transition, Variants } from 'framer-motion';

export const MOTION_DURATION = {
  quick: 0.2,
  standard: 0.28,
  relaxed: 0.35,
} as const;

export const MOTION_EASING = {
  enter: 'easeOut',
  exit: 'easeIn',
} as const;

export const openTransition: Transition = {
  duration: MOTION_DURATION.standard,
  ease: MOTION_EASING.enter,
};

export const closeTransition: Transition = {
  duration: MOTION_DURATION.quick,
  ease: MOTION_EASING.exit,
};

export const relaxedOpenTransition: Transition = {
  duration: MOTION_DURATION.relaxed,
  ease: MOTION_EASING.enter,
};

export const fadeVariants: Variants = {
  hidden: {
    opacity: 0,
    transition: closeTransition,
  },
  visible: {
    opacity: 1,
    transition: openTransition,
  },
};

export const scaleVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
    transition: closeTransition,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: openTransition,
  },
};

export const slideUpFadeVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 12,
    transition: closeTransition,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: openTransition,
  },
};

export const dialogBackdropVariants: Variants = {
  hidden: {
    opacity: 0,
    transition: closeTransition,
  },
  visible: {
    opacity: 1,
    transition: openTransition,
  },
};

export const dialogContentVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
    y: 14,
    transition: closeTransition,
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: relaxedOpenTransition,
  },
};

export const stepSlideVariants: Variants = {
  enter: (direction: number = 1) => ({
    opacity: 0,
    x: direction > 0 ? 28 : -28,
  }),
  center: {
    opacity: 1,
    x: 0,
    transition: relaxedOpenTransition,
  },
  exit: (direction: number = 1) => ({
    opacity: 0,
    x: direction > 0 ? -28 : 28,
    transition: closeTransition,
  }),
};

export const interactiveCardVariants: Variants = {
  idle: {
    scale: 1,
    y: 0,
    transition: openTransition,
  },
  hover: {
    scale: 1.05,
    y: -2,
    transition: {
      duration: MOTION_DURATION.quick,
      ease: MOTION_EASING.enter,
    },
  },
  tap: {
    scale: 0.97,
    y: 0,
    transition: {
      duration: MOTION_DURATION.quick,
      ease: MOTION_EASING.exit,
    },
  },
  selected: {
    scale: 1.02,
    y: -2,
    transition: openTransition,
  },
};
